import { Button } from "component-library";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routes } from "../../routing/routes";
import PersonImage from "./assets/person.svg?react";
import {
  ClockIcon,
  QuestionMarkCircleIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";
import { Info } from "../../components/info";

export const IntroPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClicked = () => {
    navigate(routes.questionnaire.personalInformation);
  };

  return (
    <div className="flex flex-col items-center gap-10">
      <span className="text-2xl text-text-primary">
        {t("pages.intro.title")}
      </span>
      <PersonImage className="max-w-full w-[279px] text-primary" />
      <div className="flex flex-col gap-6">
        <Info Icon={QuestionMarkCircleIcon}>{t("pages.intro.part_one")}</Info>
        <Info Icon={ShieldCheckIcon}>{t("pages.intro.part_two")}</Info>
        <Info Icon={ClockIcon}>{t("pages.intro.part_three")}</Info>
      </div>
      <Button
        className="w-full text-lg py-2"
        variant="contained"
        onClick={handleClicked}
      >
        {t("pages.intro.submit")}
      </Button>
    </div>
  );
};
